import { createContext } from 'react';
/**
 * Citrus form management and validation context
 *
 * @type React.Context
 */
export var CitrusFormContext = createContext({
    form: null,
    dispatch: (function () { return undefined; }),
});
